import {getClosestLine, getClosestPointOnLine} from "./coordinatesHelper";
import EventManager from "../components/canvas/store/sqftEventManager";
import PointV2, {CORE_POINT_LAYOUTS} from "../components/canvas/core/shapes/pointV2";
import {getMousePositionOnShape} from "./sqftHelper";

/**
 * @param pos {{x: int, y: int}}
 * @param parent
 * @return {PointV2}
 */
export const getSeamCutPoint = (pos, parent) => {
  let pointState = {
    priority: EventManager.priorities.BOX_POINT,
    movable: true,
    isCentered: true,
    isResizedByPoint: false,
    isScaledByPoint: false,
    isVisibleOnHover: true,
    moveCallback: (mousePos, movable, xDiff, yDiff) => {
      void xDiff;
      void yDiff;
      const shape = movable.grandParent;
      const mousePosOnShape = getMousePositionOnShape(mousePos.x, mousePos.y, shape);
      const closestLine = getClosestLine(shape.getLines(), mousePosOnShape);
      const newPos = getClosestPointOnLine(closestLine.from, closestLine.to, mousePosOnShape);
      movable.parent.setPosition(newPos);
    },
    mouseUpCallback: (mousePos, movablePoint) => {
      void mousePos;
      void movablePoint;
      //console.log('mousePos', mousePos);
      //console.log('movablePoint', movablePoint);
    },
    mouseDownCallback: (mousePos, movablePoint) => {
      //console.log('mouseDownCallback mousePos', mousePos);
      //console.log('mouseDownCallback movablePoint', movablePoint);
      void mousePos; void movablePoint;
    }
  };

  let pointDesign = {
    radius: 10,
    lineWidth: 1,
    layout: CORE_POINT_LAYOUTS.black
  };

  return new PointV2(pos.x, pos.y, parent, pointState, pointDesign);
}

